










/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */

/* API */

export default Vue.extend({
  name: 'IfpFilterSpam',

  methods: {
    handleCloseClick() {
      this.$emit('spam-updated', false)
    },
  },
})
